<template>
  <div>
    <div class="list-option">
      <div>
        <div class="service-option">
          <div class="title-option">option</div>
          <div class="title-option">ราคาขาย</div>
        </div>
        <div
          v-for="(serviceOption, serviceIndex) in packageOptions"
          :key="serviceIndex"
          class="group-option"
        >
          <div class="grid-price">
            <div class="title-option-head">
              {{ serviceOption.serviceTitle }}
            </div>
            <div v-if="serviceOption.servicePrice" class="title-option-price">
              {{ serviceOption.servicePrice }}
            </div>
          </div>
          <div v-if="serviceOption.serviceVariants">
            <div
              v-for="(
                serviceVariant, serviceVariantIndex
              ) in serviceOption.serviceVariants"
              :key="serviceVariantIndex"
              class="service-variant"
            >
              <div
                v-for="(variant, variantIndex) in serviceVariant.variants"
                :key="variantIndex"
              >
                <div v-if="!variant.isNotSale">
                  <div v-if="!variant.isExtraOption" class="grid-price">
                    <div>
                      <input
                        :value="true"
                        :name="serviceOption.serviceTitle"
                        :checked="variant.isVariantSelected"
                        class="radio-option"
                        type="radio"
                        @change="
                          handleSelectMainVariant(
                            serviceOption.serviceId,
                            serviceVariant.id,
                            variant.id
                          )
                        "
                      />{{ variant.title }}
                    </div>
                    <div class="title-option-detail">{{ variant.price }}</div>
                  </div>

                  <div v-if="variant.isExtraOption" class="grid-price">
                    <div>
                      <el-checkbox
                        :value="variant.isVariantSelected"
                        class="checkbox-variant"
                        @change="
                          handleSelectExtraVariant(
                            $event,
                            serviceOption.serviceId,
                            serviceVariant.id,
                            variant.id
                          )
                        "
                        >{{ variant.title }}</el-checkbox
                      >
                    </div>
                    <div class="title-option-detail">+ {{ variant.price }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="title-head-package">
        <div>สรุป</div>
        <service-list-item
          v-for="service in services"
          v-bind="service"
          :key="service.id"
          class="service"
        ></service-list-item>
      </div>
    </div>
    <div class="grid-summary">
      <div>
        <p>ราคาแพ็คแกจ</p>
        <el-input :value="packagePrice" type="text" readonly />
      </div>
      <div>
        <p>จำนวนการซื้อแพ็คเกจ</p>
        <el-input v-model="quality" type="number" min="1" />
      </div>
      <div v-if="data && data.packageId && value.canUseCoupon">
        <p>Code ส่วนลด</p>
        <coupon-select
          :package-id="data.packageId"
          :value="coupon"
          @selectCoupon="handleChangeCoupon"
        ></coupon-select>
      </div>
      <div v-if="value.canUseCoupon">
        <p>ส่วนลดจาก Code</p>
        <el-input v-model="discountAmount" readonly />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-2 price">
        <p>ราคาสุทธิ</p>
        <el-input v-model="totalPrice" type="text" readonly />
      </div>
      <div v-if="value.canUseCoupon" class="col-3 price">
        <el-checkbox
          :value="isWithholding"
          @input="handleSelectWithholding($event)"
        ></el-checkbox>
        มีหัก ณ ที่จ่าย
        <el-input :value="totalPriceWithholding" type="text" readonly/>
      </div>
    </div>
  </div>
</template>

<script>
import CouponSelect from "@/lib/components/CouponSelect";
import {
  convertBathToStangAndRoundTwoDecimal,
  formatDecimal
} from "@/lib/formatter";
import {
  calculatePackagePrice,
  mapPackageOptionsToServices
} from "@/presenters/subscriptions/serviceOptionPresenter";
import { Checkbox, Input } from "element-ui";
import ServiceListItem from "../../services/components/ServiceListItem";

export default {
  components: {
    "el-checkbox": Checkbox,
    ServiceListItem,
    "el-input": Input,
    CouponSelect,
  },
  props: {
    value: { type: Object, required: true },
    data: { type: Object, default: null },
    coupon: { type: Object, default: null },
  },
  data() {
    return {
      packagePrice: null,
      totalPrice: null,
      discountAmount: null,
      quality: 1,
    };
  },
  computed: {
    packageOptions() {
      return this.value.packageOptions;
    },
    services() {
      if (!this.data || !this.data.services) return [];
      return mapPackageOptionsToServices(this.data.services, this.value.packageOptions);
    },
    calculatedPackagePrice() {
      if (!this.data || !this.data.services) return null;
      return calculatePackagePrice(this.services, this.data.packagePrice);
    },
    isWithholding() {
      return this.value.isWithholding;
    },
    totalPriceWithholding() {
      return this.value.totalPriceWithholding;
    }
  },
  watch: {
    // NOTE: Keep packagePrice above calculatedPackagePrice; its immediate run must be observed.
    packagePrice(packagePriceChanging) {
      this.quality = 1;
      const { totalPrice, discountAmount } = this.applyCoupon(this.coupon, packagePriceChanging);
      this.totalPrice = totalPrice;
      this.discountAmount = discountAmount;

      this.$emit("input", {
        ...this.value,
        quality: 1,
        totalPrice,
        packagePrice: packagePriceChanging,
        discountAmount
      });
    },
    calculatedPackagePrice: {
      immediate: true,
      handler(newVal) {
        this.packagePrice = newVal;
      }
    },
    quality(newValue, oldValue) {
      if (newValue === "" || newValue == null) return;

      const numericValue = Number(newValue);
      if (
        !Number.isFinite(numericValue)
        || !Number.isInteger(numericValue)
        || numericValue < 1
      ) {
        this.$message.error("จำนวนแพ็คเกจต้องเป็นจำนวนเต็มและมากกว่า 0");
        this.$emit("input", { ...this.value, quality: oldValue });
        this.quality = oldValue;
        return;
      }

      const rawTotal = this.packagePrice * numericValue;
      const { totalPrice, discountAmount } = this.applyCoupon(this.coupon, rawTotal);
      this.totalPrice = totalPrice;
      this.discountAmount = discountAmount;

      this.$emit("input", {
        ...this.value,
        quality: newValue,
        totalPrice,
        discountAmount
      });
    }
  },
  methods: {
    buildSelectedOption(variant, serviceId) {
      return {
        isExtraOption: variant.isExtraOption,
        price: variant.price,
        title: variant.title,
        id: variant.id,
        isVariantSelected: variant.isVariantSelected,
        isNotSale: variant.isNotSale,
        serviceId
      };
    },
    updateVariantTree(packageOptions, serviceId, mapServiceOption) {
      return packageOptions.map((serviceOption) => {
        if (serviceOption.serviceId !== serviceId) return serviceOption;
        return {
          ...serviceOption,
          serviceVariants: mapServiceOption(serviceOption)
        };
      });
    },
    applyCoupon(coupon, rawTotal) {
      if (!coupon) {
        return { totalPrice: rawTotal, discountAmount: this.discountAmount };
      }

      let { discountAmount } = this;

      if (coupon.discount_amount) {
        discountAmount = convertBathToStangAndRoundTwoDecimal(coupon.discount_amount);
      } else if (coupon.discount_percent_amount) {
        let actual = formatDecimal(
          convertBathToStangAndRoundTwoDecimal(coupon.discount_percent_amount) * rawTotal
        );
        const rawMax = coupon.maximum_discount_amount;
        const max = rawMax ? convertBathToStangAndRoundTwoDecimal(rawMax) : null;
        if (max && actual > max) actual = max;
        discountAmount = actual;
      }

      const totalPrice = rawTotal > discountAmount
        ? formatDecimal(rawTotal - discountAmount)
        : 0;

      return { totalPrice, discountAmount };
    },
    handleSelectExtraVariant(event, serviceId, serviceVariantId, variantId) {
      let extraOptionSelected = [...this.value.extraOptionSelected];

      const packageOptions = this.updateVariantTree(
        this.value.packageOptions,
        serviceId,
        (serviceOption) => serviceOption.serviceVariants.map((serviceVariant) => {
          if (serviceVariant.id !== serviceVariantId) return serviceVariant;

          return {
            ...serviceVariant,
            variants: serviceVariant.variants.map((variant) => {
              if (variant.id !== variantId) return variant;

              const updatedVariant = { ...variant, isVariantSelected: event };

              if (event) {
                extraOptionSelected = [
                  ...extraOptionSelected,
                  this.buildSelectedOption(updatedVariant, serviceOption.serviceId)
                ];
              } else {
                extraOptionSelected = extraOptionSelected.filter(
                  (item) => item.id !== updatedVariant.id
                );
              }

              return updatedVariant;
            })
          };
        })
      );

      this.$emit("input", {
        ...this.value,
        packageOptions,
        extraOptionSelected
      });
    },
    handleSelectMainVariant(serviceId, serviceVariantId, variantId) {
      const mainOptionSelected = [...this.value.mainOptionSelected];

      const packageOptions = this.value.packageOptions.map((serviceOption, serviceOptionIndex) => {
        if (serviceOption.serviceId !== serviceId) return serviceOption;

        return {
          ...serviceOption,
          serviceVariants: serviceOption.serviceVariants.map((serviceVariant) => {
            if (serviceVariant.id === serviceVariantId) {
              return {
                ...serviceVariant,
                variants: serviceVariant.variants.map((variant) => {
                  if (variant.id !== variantId) return variant;

                  const updatedVariant = { ...variant, isVariantSelected: true };
                  mainOptionSelected[serviceOptionIndex] = this.buildSelectedOption(
                    updatedVariant,
                    serviceOption.serviceId
                  );

                  return updatedVariant;
                })
              };
            }

            return {
              ...serviceVariant,
              variants: serviceVariant.variants.map((variant) => {
                if (variant.id === variantId) return variant;
                return { ...variant, isVariantSelected: false };
              })
            };
          })
        };
      });

      this.$emit("input", {
        ...this.value,
        packageOptions,
        mainOptionSelected
      });
    },
    handleChangeCoupon(coupon) {
      if (!coupon) {
        this.$emit("selectCoupon", null);
        this.discountAmount = null;
        return;
      }

      this.$emit("selectCoupon", coupon);

      const rawTotal = this.packagePrice * this.quality;
      const { totalPrice, discountAmount } = this.applyCoupon(coupon, rawTotal);
      this.discountAmount = discountAmount;
      this.totalPrice = totalPrice;

      this.$emit("input", {
        ...this.value,
        discountAmount,
        totalPrice
      });
    },
    handleSelectWithholding(value) {
      const total = this.totalPrice;

      let totalPriceWithholding = null;
      if (value === true) {
        const priceExcludeVat = formatDecimal(total * 100 / 107) || 0

        const priceVatAndWithholding = priceExcludeVat
          ? formatDecimal(total - (formatDecimal(priceExcludeVat * 0.03) || 0))
          : 0

        totalPriceWithholding = formatDecimal(priceVatAndWithholding) || 0;
      }

      this.$emit("input", {
        ...this.value,
        isWithholding: value,
        totalPriceWithholding
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.list-option {
  display: grid;
  grid-template-columns: 470px auto;
  height: auto;
}

.service-option {
  border: $border-head;
  height: 50px;
  background-color: #f2f2f2;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  display: grid;
  grid-template-columns: 350px 120px;
}

.grid-price {
  display: grid;
  grid-template-columns: 350px 120px;
}

.title {
  &-option {
    border-right: $border;
    padding-left: 10px;
    padding-top: 10px;
    font-size: 15px;
    font-weight: normal;
  }

  &-option-head {
    padding: 10px;
    font-size: 18px;
    font-weight: bold;
  }

  &-option-detail {
    font-size: 15px;
    font-weight: normal;
  }

  &-option-price {
    padding: 10px;
    font-size: 15px;
    font-weight: normal;
  }

  &-head-package {
    padding-left: 20px;

    font-size: 20px;
    font-weight: bold;
  }
}

.group-option {
  border: $border-head;
  border-top: 0;

  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.service-variant {
  padding-left: 10px;
}

.checkbox-variant {
  padding-left: 15px;
}

.radio-option {
  transform: scale(1.25);
  margin-right: 15px;
  margin-bottom: 10px;
}

.grid-summary {
  padding-top: 20px;
  display: grid;
  grid-template-columns: auto auto auto auto;
  grid-gap: 20px;
}

.price {
  width: 200px;
}
</style>